import {Language, LeaguePrivacy} from "data/enums";
import logoEn from "assets/img/cfl-small-white-logo.png";
import logoFr from "assets/img/cfl-small-white-logo-french.png";

import pickEmLogoEn from "assets/img/cfl-pickem-logo.png";
import pickEmLogoFr from "assets/img/cfl-pickem-logo-fr.png";

export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const SHARE_URL = process.env.REACT_APP_FB_SHARE_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const GZ_IMAGES_URL = process.env.REACT_APP_GZ_LINK || "";

// Sentry
export const SENTRY_DOMAIN_ALLOWED =
	"gamezone.cfl.ca, zonejeux.lcf.ca, .f2p.media.geniussports.com";

export const logoLinks = {
	en: "https://cfl.ca/",
	fr: "https://www.lcf.ca/",
};

export const logos = {
	[Language.English]: logoEn,
	[Language.French]: logoFr,
};

export const pickEmLogos = {
	[Language.English]: pickEmLogoEn,
	[Language.French]: pickEmLogoFr,
};

export const DEFAULT_LEAGUES_FETCH_LIMIT = 10;

export const EMAIL_PATTERN = "[A-za-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$";

export const leaguePrivacyTexts = {
	[LeaguePrivacy.Private]: "leagues.privacy.private",
	[LeaguePrivacy.Public]: "leagues.privacy.public",
};

export const roundSelectStyle = {fontFamily: "Hind, sans-serif", borderRadius: 4};

export * from "./socialNetworkLinks";
export * from "./routing";
export * from "./subMenuRouting";
export * from "./helpPagesRouting";
